import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import parse from "html-react-parser";

import "./Content.scss";
import { checkQuestion } from "../../../../api/training";

export class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allQuestions: [], // Toutes les questions
      allContent: "", // Contenu du module
      step: 0,
    };
  }

  componentDidMount() {
    this.getDatas();
  }

  /**
   * Récupere le contenu
   */
  getDatas = () => {
    const { step } = this.state;

    const dataContents = this.props.questions;
    const dataContent = this.props.questions[step].content;
    const questionId = this.props.questions[step].id;

    this.setState({
      allQuestions: dataContents,
      allContent: dataContent,
      questionId,
    });
  };

  /**
   * Passe au mini-jeu suivant
   */
  nextStep = () => {
    const { step, questionId } = this.state;
    const { isPreview, moduleId } = this.props;
    if (isPreview) {
      this.handleNextStep();
      return;
    }

    checkQuestion(moduleId, questionId, ["compris"]).then((data) =>
      this.handleNextStep()
    );
  };

  handleNextStep = () => {
    const { step, questionId } = this.state;
    const { isPreview, moduleId } = this.props;

    if (step < this.state.allQuestions.length - 1) {
      this.props.onAnswer(true);
      this.setState(
        {
          step: step + 1,
        },
        () => {
          this.getDatas();
        }
      );
    } else {
      this.props.onModuleEnd();
      this.props.onAnswer(true);
      this.setState(
        {
          step: 0,
        },
        () => {
          this.getDatas();
        }
      );
    }
  };

  render() {
    const { allContent } = this.state;
    const { t } = this.props;
    return (
      <div className="content_wrapper">
        <div className="content_container course">
          {allContent ? parse(allContent) : null}
        </div>
        <div className="btn_verif" onClick={this.nextStep}>
          {t("understood")} !
        </div>
      </div>
    );
  }
}

export default withTranslation()(Content);
